import firebase from "gatsby-plugin-firebase"
import {
  GoogleAuthProvider,
  FacebookAuthProvider,
} from "../auth/FirebaseProviders"

export const startLogin = provider => {
  console.log("sign in started")
  const signInProvider = () => {
    switch (provider) {
      case "google":
        return GoogleAuthProvider
      case "facebook":
        return FacebookAuthProvider
      default:
        return null
    }
  }

  return dispatch => {
    return firebase
      .auth()
      .signInWithPopup(signInProvider())
      .then(function(result) {
        // // This gives you a Facebook Access Token. You can use it to access the Facebook API.// var token = result.credential.accessToken;// // The signed-in user info.// var user = result.user;
        console.log("User has Signed In")
        const { uid, displayName, email, photoURL } = result.user

        // adds user to the database or updates their details.
        firebase
          .database()
          .ref(`users/${uid}/acceptEmails`)
          .once("value", snapshot => {
            firebase
              .database()
              .ref(`/users/${uid}`) // creates the object using uid from firebase auth
              .update({
                uid,
                displayName,
                email,
                photoURL,
                acceptEmails: snapshot.val() !== null ? snapshot.val() : true,
              })
            // if acceptemails doesnt exist render true as default else write snapshot to database val
          })
      })
      .catch(function(error) {
        // // Handle Errors here.
        console.log(error)
        const errorCode = error.code
        const errorMessage = error.message
        dispatch(throwAuthError(errorCode, errorMessage))
        // console.log(error)
        // // The email of the user's account used.
        // const email = error.email
        // // The firebase.auth.AuthCredential type that was used.
        // const credential = error.credential;
        // // ...
      })
  }
}

export const login = (uid, displayName, email, photoURL) => ({
  type: "LOGIN",
  uid,
  displayName,
  email,
  photoURL,
})

export const startLogout = () => {
  console.log("Started Signing out")
  return () => {
    return firebase.auth().signOut()
  }
}

export const logout = () => ({
  type: "LOGOUT",
})

export const throwAuthError = (errorCode, errorMessage) => ({
  type: "AUTH_ERROR",
  errorCode,
  errorMessage,
})

export const resetState = () => ({
  type: "RESET_STATE",
})
